import { css } from 'lit'

export const cscRmaError = {
  detailColor: css`var(--csc-rma-error-detail-color, var(--cs-color-error, #dc3545))`,
}

export const rmaError = css`
  .rma-error {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-m, 1rem);
    padding: var(--spacing-l, 1.5rem) 0;
  }

  .rma-error__detail {
    margin: 0;
    color: ${cscRmaError.detailColor};
  }
`
